import { React, useState } from 'react';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';

const EmailTrocaTitularidade = () => {
    const [ccs, setCCs] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [saida, setSaida] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitEmail (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            ccs,
            saida
        });
        const response = await fetchFlask('emailTrocaTitularidade', body);
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
        if (response.status === 'success') {
            setCCs('');
        }
        setIsSubmit(false);
    };

    return (
        <Box className='mainBox'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                {saida ? 'SAÍDA DO CONSÓRCIO' : 'ENTRADA NO CONSÓRCIO'}
            </PageHeader>

            <form action='' method='POST' id='formTrocaTitularidade' onSubmit={submitEmail}>
                <FormControlLabel label={saida ? 'SAÍDA' : 'ENTRADA'}
                    control={
                        <Switch
                            onChange={(e) => { setSaida(!saida); }}
                    />
                    }
                />

                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <TextField
                        label='Conta Contratos'
                        id='obs'
                        required
                        multiline
                        minRows={4}
                        maxRows={10}
                        value={ccs}
                        onChange={(e) => setCCs(e.target.value)}
                    />
                </FormControl>

                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <SubmitButton isSubmit={isSubmit}>Enviar E-mails</SubmitButton>
                </FormControl>
            </form>
        </Box>
    );
};

export default EmailTrocaTitularidade;
